import { api } from './'
import { CARRELLOLATER } from './endpoint'

export const FetchCarrelloLater = async (setLoading, setCarrelloLater, router) => {
  setLoading(true)
  api
    .get(CARRELLOLATER, { params: { lang: router.locale } })
    .then((response) => {
      setCarrelloLater(response.data)
      setLoading(false)
    })
    .catch(() => setLoading(false))
}

export const getError = (error, fallback = 'Qualcosa è andato storto') => {
  const data = error?.response?.data

  return data?.message ||
    data?.error?.message ||
    data?.detail ||
    data?.non_field_errors?.[0] || fallback
}
